import { useNavigate } from "react-router-dom";
import { usePlatformAuth } from "../hooks/usePlatformAuth";
import { colors, fontSize, fontWeight, radius, shadow } from "../lib/tokens";

export function AccessDeniedPage() {
  const { signOut, session } = usePlatformAuth();
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: colors.paper, padding: 24 }}>
      <div style={{ background: colors.white, border: `1px solid ${colors.fog}`, borderRadius: radius.lg, boxShadow: shadow.md, padding: 32, width: "100%", maxWidth: 420, textAlign: "center" }}>
        <h1 style={{ fontSize: 22, fontWeight: fontWeight.medium, letterSpacing: "-0.015em", marginBottom: 12 }}>Sem acesso</h1>
        <p style={{ fontSize: fontSize.md, color: colors.stone, marginBottom: 24 }}>
          A conta <strong>{session?.user?.email}</strong> não tem permissão para acessar o platform admin.
        </p>
        <button
          onClick={async () => { await signOut(); navigate("/login"); }}
          style={{ height: 36, padding: "0 14px", background: colors.ink, color: colors.paper, border: 0, borderRadius: radius.sm, fontSize: fontSize.md, fontWeight: fontWeight.medium, cursor: "pointer" }}
        >
          Sair e voltar ao login
        </button>
      </div>
    </div>
  );
}
